import { Col } from 'components/Col';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { useContext, useEffect, useMemo } from 'react';
import { getOptionsFromParams } from 'utils/DropdownUtils';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.codigoCooperativa;
export default function Cooperativa() {
  const { state, dispatch, validator, loadCooperativas } =
    useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'codigoCooperativa',
        etapa: EtapaProjeto.infosIniciais,
        helperText: languageValues.inputs.codigoCooperativa.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  useEffect(() => {
    loadCooperativas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const escola = state.options.instituicao.options.find(
      (e) => state.projeto.idEscola === e.id
    );

    if (escola && state.projeto.codigoCooperativa !== escola.coop) {
      dispatch({
        type: 'setProjeto',
        payload: { codigoCooperativa: escola.coop },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.projeto.idEscola]);

  const options = useMemo(() => {
    return state.options.cooperativa.options
      ? getOptionsFromParams(
          state.options.cooperativa.options,
          'codigo',
          (coop) => coop.nome.toUpperCase()
        )
      : [];
  }, [state.options.cooperativa.options]);

  return (
    <Row>
      <Col>
        <NewAutoCompleteField
          disabled
          label={language.label}
          placeholder={language.placeholder}
          loading={state.options.cooperativa.loading}
          loadingMessage={language.loading}
          options={options}
          value={state.projeto.codigoCooperativa}
          onChange={(option: { value: string; label: string }) => {
            dispatch({
              type: 'setProjeto',
              payload: { codigoCooperativa: option?.value ?? null },
            });
          }}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
        />
      </Col>
    </Row>
  );
}
